import debounce from 'lodash/debounce';
import type { SegmentFilters } from '../../components/SegmentsList/types.ts';

export const debouncedHandleSearch = debounce(
  (value: string, currentFilters: SegmentFilters, changeFilters: (value: SegmentFilters) => void) => {
    changeFilters({ ...currentFilters, phrase: value });
  },
  300
);
